import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import { useUserFromQuery } from '@/components/Profile/helpers'
import ProfileFeaturedFeedback from '@/components/Profile/ProfileFeaturedFeedback'
import ProfileLayout from '@/components/Profile/ProfileLayout'

function ProfileFeedback(): JSX.Element {
  const { user } = useUserFromQuery()

  return (
    <ProfileLayout currentTab="Feedback">
      <ProfileFeaturedFeedback user={user} limit={Number.POSITIVE_INFINITY} />
    </ProfileLayout>
  )
}

const ProfileFeedbackPage = makePage(ProfileFeedback, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(ProfileFeedbackPage)
export default ProfileFeedbackPage
